export enum LockType {
  FULL = 'full',
  XFAACTIVATION = 'xfa-activation',
  XFAACTIVATIONCALLDOWN = 'xfa-activation-call-down',
  STXFA = 'xfa-activation-stxfa',
  PROACCOUNT = 'xfa-activation-pro',
  MULTIPLEPROFILES = 'multiple-profiles',
  PROFILEDEACTIVATED = 'profile-deactivated',
  KYCHOLD = 'kyc-hold',
  UNDERAGE = 'underage',
  ATO = 'ato',
  FTPSLOWDOWN = 'ftp-slowdown',
  FTPCORRECTIVE = 'ftp-corrective',
  RTP = 'rtp',
  RTPMPU = 'rtp-mpu',
  REGIONS = 'regions',
  EXCESSIVECHARGEBACK = 'excessive-chargeback',

  // system-only locks
  TCPURCHASELIMIT = 'tc-purchase-limit',
  RESETLIMIT = 'reset-limit',
  IDVHOLDAUTO = 'idv-hold-auto',

  // legacy locks
  TCANDRESETS = 'trading-combines-and-resets',
  OTHER = 'other',

  // removed
  RESET = 'reset',
  PURCHASE = 'purchase',
  PURCHASETC = 'purchase-tc',
  COMBINEANDRESETPURCHASE = 'combine-and-rest-purchase',
  ADDON = 'addon',
  PRACTICEACCOUNT = 'practice-account',
  INVESTIGATION = 'investigation',
  CTP = 'ctp',
  XFACOOLDOWN = 'xfa-cooldown',
  PROFILEDELETION = 'profile-deletion',
  PAYOUT = 'payout',
  PRTF = 'prtf',
  DLLREQUIRED = 'dll-required',
  FTPCONSISTENCYTARGET = 'ftp-consistency-target',
}
